import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div style={styles.container}>
      {/* Animated Background */}
      <div style={styles.backgroundAnimation}></div>
      
      <div style={styles.content}>
        {/* Hero Section */}
        <div style={styles.hero}>
          <div style={styles.shieldIcon}>🛡️</div>
          <h1 style={styles.title}>Placement Tracker System</h1>
          <p style={styles.subtitle}>
            Track, Manage, and Monitor Student Placements with Ease
          </p>
        </div>

        {/* Cards Section */}
        <div style={styles.cardContainer}>
          {/* Student Portal Card */}
          <Link to="/student-registration" style={styles.cardLink}>
            <div style={styles.card}>
              <div style={styles.cardIcon}>👨‍🎓</div>
              <h3 style={styles.cardTitle}>Student Portal</h3>
              <p style={styles.cardDescription}>
                Register and add your skills, interviews, and placement details
              </p>
              <div style={styles.cardButton}>Get Started →</div>
            </div>
          </Link>

          {/* Faculty Portal Card */}
          <Link to="/faculty-signup" style={styles.cardLink}>
            <div style={styles.card}>
              <div style={styles.cardIcon}>👨‍🏫</div>
              <h3 style={styles.cardTitle}>Faculty Portal</h3>
              <p style={styles.cardDescription}>
                Monitor students, view analytics, and manage placements
              </p>
              <div style={styles.cardButton}>Access Dashboard →</div>
            </div>
          </Link>

          {/* Login Portal Card */}
          <Link to="/login" style={styles.cardLink}>
            <div style={styles.card}>
              <div style={styles.cardIcon}>🔐</div>
              <h3 style={styles.cardTitle}>Login Portal</h3>
              <p style={styles.cardDescription}>
                Universal login for students and faculty members
              </p>
              <div style={styles.cardButton}>Sign In →</div>
            </div>
          </Link>
        </div>

        {/* Features Section */}
        <div style={styles.features}>
          <div style={styles.feature}>
            <span style={styles.featureIcon}>📊</span>
            <span style={styles.featureText}>Real-time Analytics</span>
          </div>
          <div style={styles.feature}>
            <span style={styles.featureIcon}>🎯</span>
            <span style={styles.featureText}>Track Progress</span>
          </div>
          <div style={styles.feature}>
            <span style={styles.featureIcon}>🔒</span>
            <span style={styles.featureText}>Secure & Private</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 2rem 4rem 2rem',
    position: 'relative',
    overflow: 'hidden',
  },
  backgroundAnimation: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)',
  },
  content: {
    maxWidth: '1200px',
    width: '100%',
    position: 'relative',
    zIndex: 1,
  },
  hero: {
    textAlign: 'center',
    marginBottom: '3rem',
  },
  shieldIcon: {
    fontSize: '70px',
    marginBottom: '1rem',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '700',
    color: 'white',
    margin: '0 0 1rem 0',
    textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: 'rgba(255,255,255,0.9)',
    maxWidth: '600px',
    margin: '0 auto',
  },
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '1.5rem',
    marginBottom: '3rem',
    justifyItems: 'center',
    alignItems: 'stretch',
  },
  cardLink: {
    textDecoration: 'none',
    width: '100%',
    maxWidth: '300px',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '2rem 1.5rem',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    border: '2px solid rgba(255,255,255,0.3)',
    height: '100%',
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardIcon: {
    fontSize: '50px',
    marginBottom: '1rem',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 0.8rem 0',
    minHeight: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardDescription: {
    fontSize: '0.9rem',
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '1.2rem',
    minHeight: '65px',
    flex: 1,
  },
  cardButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '0.75rem 1.2rem',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '0.95rem',
    transition: 'transform 0.2s ease',
    marginTop: 'auto',
  },
  features: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    flexWrap: 'wrap',
    marginTop: '3rem',
    paddingTop: '2rem',
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.7rem',
    background: 'rgba(255,255,255,0.2)',
    backdropFilter: 'blur(10px)',
    padding: '0.9rem 1.8rem',
    borderRadius: '50px',
    border: '2px solid rgba(255,255,255,0.3)',
  },
  featureIcon: {
    fontSize: '1.4rem',
  },
  featureText: {
    color: 'white',
    fontWeight: '600',
    fontSize: '1rem',
  },
};

export default Home;
